import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type UseEditAnnotationCommentMutationVariables = {
  commentId: string;
  message?: string;
  metadata?: {
    attachments: Array<{
      filename: string;
    }>;
    [key: string]: any;
  };
};

export const useEditAnnotationCommentMutation = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: async ({
      commentId,
      ...payload
    }: UseEditAnnotationCommentMutationVariables) => {
      const { data } = await authApi.patch(
        `/virtual-tour/annotation/comment/${commentId}`,
        payload
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["virtual-tour-annotations"], // TODO: invalidate only the specific annotation
      });
    },
  });

  return result;
};
